import { RootState } from "../../store";

export const authAndRegSelector = (state: RootState) => state.authAndReg;

export const isAuthenticatedSelector = (state: RootState): boolean => {
  const { auth } = state.authAndReg;
  const hasToken = !!state.auth?.accessToken;
  return auth || hasToken;
};